import React, {useEffect, useState} from "react";
import {Button, Col, FormGroup, Label, Row, Spinner} from "reactstrap";
import Select from "react-select";
import {FormControl} from "react-bootstrap";
import {getSelectedObject} from "../../util/Helper";
import {talentProgramSource} from "../../util/talentProgramSource";
import {NotificationManager} from "react-notifications";

const CandidateSpecific = (props) => {
  const [candidateSpecific, setCandidateSpecific] = useState({});
  const drivingLicenseValidity = [
    { value: "Yes", label: "Yes" },
    { value: "No", label: "No" },
  ];

  useEffect(() => {
      console.log({...props.candidateSpecific});
    setCandidateSpecific({ ...props.candidate });
  }, []);

    const isFieldEnabled = (fieldName) =>
        props.candidateSpecific.fields[fieldName]?.enabled;

    const theLabelName = (fieldName) => props.candidateSpecific.fields[fieldName]?.label;

    useEffect(() => {
    }, [candidateSpecific]);

  const handleChange = (e) => {
    setCandidateSpecific({
      ...candidateSpecific,
      [e.target.name]: e.target.value,
    });
  };


  const handleValidation = () => {
      const {
          drivingLicenseValidity,
          personality,
          talentProgramSource,
      } = candidateSpecific;

      // Check if all fields are filled
      if (
          (isFieldEnabled("drivingLicenseValidity") && !drivingLicenseValidity) ||
          (isFieldEnabled("personality") && !personality) ||
          (isFieldEnabled("talentProgramSource") && !talentProgramSource)
      ) {
          // NotificationManager.error("Please fill in all the required fields.");
      return false;
    }

      // All required fields are valid
    return true;
  };

    // const handleValidation = () => {
    //   const { drivingLicenseValidity, personality } = candidateSpecific;

    //   // Check if drivingLicenseValidity is filled
    //   if (!drivingLicenseValidity || !personality) {
    //     return false;
    //   }
    //   return true;
    // };
  const handleNext = async () => {
    if (handleValidation()) {
        const completeData = {...props.candidate, ...candidateSpecific};
      props.setCandidate(completeData);
      await props.handleSubmit(completeData);
    } else {
      NotificationManager.error("Please fill in all the required fields.");
    }
  };

  return (
    <div className="d-flex justify-content-between">
      <Col className="px-lg-2 mt-lg-2 pt-lg-2">
        <div className={"text-center "}>
          <h3 className="secondary-heading">Candidate Specific</h3>
        </div>
          {isFieldEnabled("drivingLicenseValidity") && (
              <Row className={"mt-4"}>
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {/* Do you have a valid driving license? */}
                                          {theLabelName("drivingLicenseValidity")} :{" "}
                                          <span className={"active-text"}>*</span>
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <Select
                                      className="react-select primary -border-none text-left input-grey-p-0"
                                      classNamePrefix="react-select"
                                      name="drivingLicenseValidity"
                                      options={drivingLicenseValidity}
                                      value={getSelectedObject(
                                          candidateSpecific?.drivingLicenseValidity,
                                          drivingLicenseValidity
                                      )}
                                      onChange={(selectedOption) => {
                                          setCandidateSpecific({
                                              ...candidateSpecific,
                                              drivingLicenseValidity: selectedOption?.value,
                                          });
                                      }}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              </Row>
          )}
          {isFieldEnabled("drivingLicenseFile") && (
              <Row>
                  <Col md={12}>
                      <Label className={"w-100 text-left ml-3"}>
                          <strong>
                              {theLabelName("drivingLicenseFile")} :{" "}
                              {/* If yes, please provide picture. */}
                          </strong>
                      </Label>
                      {/*  accept files  */}
                      <div
                          onClick={() => {
                              document.getElementById("drivingLicenseFile").click();
                          }}
                          className={
                              "custom-input-file input-grey d-flex justify-content-between w-100 p-1 rounded"
                          }
                      >
                          <div className={"d-flex mt-2 px-2"}>
                              <i className="fa fa-paperclip mt-1 mr-2" aria-hidden="true"/>{" "}
                              <p
                                  className={"active-text"}
                                  style={{
                                      fontWeight: "600",
                                  }}
                              >
                                  <u>
                                      <strong>
                                          {candidateSpecific?.drivingLicenseFile?.name
                                              ? candidateSpecific?.drivingLicenseFile?.name
                                              : "Choose file"}
                                      </strong>
                                  </u>
                              </p>
                          </div>

                          <Button
                              className={"startButton px-5 py-0 text-white"}
                              color={""}
                              style={{
                                  background: "#fba51b",
                              }}
                          >
                              Upload
                          </Button>
                      </div>
                      <input
                          type="file"
                          id="drivingLicenseFile"
                          name={"drivingLicenseFile"}
                          style={{display: "none"}}
                          onChange={(e) => {
                              if (!e.target.files[0]) return;
                              // check if the file has extension of pdf, doc, docx, jpg, jpeg, png, gif, tiff
                              if (
                                  ![
                                      "application/pdf",
                                      "application/msword",
                                      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                                      "image/jpeg",
                                      "image/png",
                                      "image/gif",
                                      "image/tiff",
                                  ].includes(e.target.files[0].type)
                              ) {
                                  NotificationManager.error(
                                      "File type should be pdf, doc, docx, jpg, jpeg, png, gif, tiff"
                                  );
                                  return;
                              }

                              if (e.target.files[0].size / 1024 > 1024) {
                                  NotificationManager.error(
                                      "File size should be less than 1MB"
                                  );
                                  return;
                              }
                              setCandidateSpecific({
                                  ...candidateSpecific,
                                  drivingLicenseFile: e.target.files[0],
                              });
                          }}
                      />
                  </Col>
              </Row>
          )}
          {isFieldEnabled("talentProgram") && (
              <Row className={"mt-4"}>
                  <Col md={12}>
                      <Label className={"w-100 text-left ml-3"}>
                          <strong>
                              {theLabelName("talentProgram")} :{" "}
                              {/* What are your career aspirations and how will this Talent
                Program add value to reach the desired goal? */}
                          </strong>
                      </Label>
                      <textarea
                          className={"form-control input-grey"}
                          placeholder={theLabelName("talentProgram")}
                          // placeholder={"Talent Program"}
                          name={"talentProgram"}
                          value={candidateSpecific?.talentProgram}
                          onChange={(e) => handleChange(e)}
                          style={{
                              borderRadius: "10px",
                          }}
                      ></textarea>
                  </Col>
              </Row>
          )}
          {isFieldEnabled("personality") && (
              <Row className={"mt-4"}>
                  <Col md={12}>
                      <FormGroup>
                          <Row>
                              <Col>
                                  <Label className="float-sm-left ml-3">
                                      <strong>
                                          {theLabelName("personality")} :{" "}
                                          {/* Tell us about your personality in 3 words. */}
                                          <span className={"active-text"}>*</span>
                                      </strong>
                                  </Label>
                              </Col>
                          </Row>
                          <Row>
                              <Col>
                                  <FormControl
                                      className={"input-grey"}
                                      placeholder={theLabelName("personality")}
                                      // placeholder={"Personality in 3 words"}
                                      name={"personality"}
                                      value={candidateSpecific?.personality}
                                      onChange={(e) => handleChange(e)}
                                  />
                              </Col>
                          </Row>
                      </FormGroup>
                  </Col>
              </Row>
          )}
          {isFieldEnabled("talentProgramSource") && (
        <Row className={"mt-4"}>
          <Col md={12}>
            <FormGroup>
              <Row>
                <Col>
                  <Label className="float-sm-left ml-3">
                    <strong>
                        {theLabelName("talentProgramSource")} :{" "}
                        {/* Please mention how you learned about our Talent Program
                      2023 ? */}
                        <span className={"active-text"}>*</span>
                    </strong>
                  </Label>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Select
                    className="react-select primary -border-none text-left input-grey-p-0"
                    classNamePrefix="react-select"
                    name="talentProgramSource"
                    options={talentProgramSource}
                    value={getSelectedObject(
                      candidateSpecific?.talentProgramSource,
                      talentProgramSource
                    )}
                    onChange={(selectedOption) => {
                      setCandidateSpecific({
                        ...candidateSpecific,
                        talentProgramSource: selectedOption?.value,
                      });
                    }}
                  />
                </Col>
              </Row>
            </FormGroup>
          </Col>
        </Row>
          )}
        {/*<Row className={"mt-4"}>*/}
        {/*  <Col md={12}>*/}
        {/*    <FormGroup>*/}
        {/*      <Row>*/}
        {/*        <Col>*/}
        {/*          <Label className="float-sm-left ml-3">*/}
        {/*            <strong>*/}
        {/*              If Others, Please specify*/}
        {/*              <span className={"active-text"}>*</span>*/}
        {/*            </strong>*/}
        {/*          </Label>*/}
        {/*        </Col>*/}
        {/*      </Row>*/}
        {/*      <Row>*/}
        {/*        <Col>*/}
        {/*          <FormControl*/}
        {/*            className={"input-grey"}*/}
        {/*            placeholder={"Please specify"}*/}
        {/*            name={"talentProgramSourceOther"}*/}
        {/*            value={candidateSpecific?.talentProgramSourceOther}*/}
        {/*            onChange={(e) => handleChange(e)}*/}
        {/*          />*/}
        {/*        </Col>*/}
        {/*      </Row>*/}
        {/*    </FormGroup>*/}
        {/*  </Col>*/}
        {/*</Row>*/}

        <Row className={"mt-4"}>
          <Col>
            <Button
              className="nextBtn startButton float-left"
              color={""}
              onClick={() => {
                  props.switchBack();
                  // props.switchComponent("orgQuestions");
                  const newProgress = Math.max(
                      (props.progress || 0) - props.progressIncrement,
                      0
                  ); // Ensure progress doesn’t go below 0
                  props.setProgress(newProgress);
                props.gotoSlide(3);
              }}
            >
              <span className="text-white font-weight-normal">Back</span>
            </Button>
            <Button
              className="beginBtn startButton float-right"
              color=""
              onClick={async () => await handleNext()}
            >
              <span className="text-white font-weight-normal">
                {props.isLoading ? (
                  <Spinner color="light" size="sm" />
                ) : (
                  "Submit"
                )}
              </span>
            </Button>
          </Col>
        </Row>
      </Col>
    </div>
  );
};

export default CandidateSpecific;
